import { IndexStatusCard } from "@/components/index/IndexStatusCard";
import { UnknownBooksCard } from "@/components/index/UnknownBooksCard";
import { ReindexButton } from "@/components/index/ReindexButton";
import { CustomerVolumeChart } from "@/components/index/CustomerVolumeChart";
import { CustomerIsolationKpi } from "@/components/index/CustomerIsolationKpi";
import { SearchMetricsKpi } from "@/components/index/SearchMetricsKpi";
import { AnswerLengthChart } from "@/components/index/AnswerLengthChart";

/**
 * v1.4 검색 관리 페이지
 * - 인덱싱 상태 / 미분류 책 / 수동 재인덱싱
 * - 고객사별 질문량 차트 / 격리 KPI
 * - 검색 기능 적용 현황 (HyDE/Hybrid/Continuation) / 답변 길이 분포
 */
export function IndexAdminPage() {
  return (
    <div className="space-y-4 p-6">
      <header className="flex items-end justify-between">
        <div>
          <h1 className="text-xl font-semibold">검색 관리</h1>
          <p className="text-xs text-muted-foreground">
            ArkiveAI 인덱싱 상태·미분류 책·고객사별 사용 현황 모니터링 및 관리
          </p>
        </div>
      </header>

      {/* 1행: 인덱싱 상태 + 미분류 책 + 재인덱싱 버튼 */}
      <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
        <IndexStatusCard />
        <UnknownBooksCard />
        <ReindexButton />
      </div>

      {/* 2행: 격리 KPI + 고객사별 차트 */}
      <div className="grid grid-cols-1 gap-3 lg:grid-cols-3">
        <div className="lg:col-span-1">
          <CustomerIsolationKpi />
        </div>
        <div className="lg:col-span-2">
          <CustomerVolumeChart />
        </div>
      </div>

      {/* 3행: 검색 기능 적용 KPI + 답변 길이 분포 (v1.4 가시화 확장) */}
      <div className="grid grid-cols-1 gap-3 lg:grid-cols-3">
        <div className="lg:col-span-1">
          <SearchMetricsKpi />
        </div>
        <div className="lg:col-span-2">
          <AnswerLengthChart />
        </div>
      </div>
    </div>
  );
}
